import moment from "moment";
import { TableAction, TableCode } from "../enums";

export class TicketLogResult {
    public id: number = 0;
    public tableCode: TableCode = TableCode.Ticket;
    public tableId: number = 0;
    public tableAction: TableAction = TableAction.AssignedEmployee;
    public dateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public employeeId: number = 0;
    public fullName: string = '';
}
